import React, { useEffect } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import Select from "react-select";
import "./SelectPGAEvent.css";
import { isToolSub } from "../../../../../../AuthUtils";
import { Redirect } from "react-router-dom";

const GET_EVENTS = graphql`
  query SelectDKContestQuery {
    whoAmI {
      username
      groups {
        name
      }
    }

    activeContests {
      id
      contestId
      name
    }
  }
`;

export default function SelectDKContest(props) {
  const data = useLazyLoadQuery(
    GET_EVENTS,
    {},
    { fetchPolicy: "network-only" }
  );

  if (!data.whoAmI || !isToolSub(data.whoAmI.groups)) {
    return <Redirect to="/memberships" />;
  }

  const firstContest = data.activeContests[0];

  let defaultValue = {};

  if (firstContest) {
    defaultValue = {
      value: firstContest.id,
      label: firstContest.name,
    };
  }

  useEffect(() => {
    if (firstContest) {
      props.setSelectedContestID(firstContest.id);
    }
  }, []);

  function updateSelectedContest(selected) {
    props.setSelectedContestID(selected.value);
  }

  return (
    <div className="select-pga-event-container">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label>
        Select Contest
        <Select
          id="event"
          className="select-pga-event-select-box"
          options={data.activeContests.map((contest) => {
            return { value: contest.id, label: contest.name };
          })}
          onChange={updateSelectedContest}
          defaultValue={defaultValue}
          style={{ zIndex: 100 }}
        />
      </label>
      <br />
    </div>
  );
}
